import React from 'react'

function LoginContainer() {
    return (
        <div>
            <img
                src="/vectorRight.png"
                alt=""
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                }}
            />
            <img
                src="/vectorLeft.png"
                alt=""
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                }}
            />
            <img
                src="/vectorLeftBottom.png"
                alt=""
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                }}
            />
            <img
                src="/vectorRightBottom.png"
                alt=""
                style={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                }}
            />

        </div>
    )
}

export default LoginContainer